// @ts-strict

import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['./primary-button.component.scss']
})
export class PrimaryButtonComponent implements OnInit, OnDestroy {
  @Input() buttonText?: string;
  @Input() icon?: string;
  @Input() background?: string;
  @Input() isDataSavingActive?: boolean;
  @Input() showSmallSpinner?: boolean;
  @Input() iconSize?: number;
  @Input() fontSize?: number;
  @Input() height?: number;
  @Input() disabled?: boolean;
  @Input() timer?: number;
  @Input() type?: string;

  @Output() emitAction = new EventEmitter();

  private interval: NodeJS.Timeout | undefined;

  public get isOrangeButton(): boolean {
    return this.background === 'orange';
  }
  public get isRedButton(): boolean {
    return this.background === 'red';
  }
  public get isWhiteButton(): boolean {
    return this.background === 'white';
  }
  public get isBlueButton(): boolean {
    return this.background === 'blue';
  }
  public get isGreyButton(): boolean {
    return this.background === 'grey';
  }
  public get isPrimary(): boolean {
    return this.background === 'primary';
  }
  public get isLightGreyButton(): boolean {
    return this.background === 'light-grey';
  }

  constructor() {}

  ngOnInit(): void {
    if (this.timer) {
      this.disabled = true;
      this.interval = setInterval(() => {
        if (this.timer) {
          this.timer--;
        }

        if (this.timer === 0) {
          clearInterval(this.interval);
          this.disabled = false;
        }
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  public handleClick(): void {
    this.emitAction.emit();
  }
}
